import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ec3af68"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_label = _resolveComponent("app-label")!

  return (_ctx.sharedTo.length)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["shared-info", {'shared-info--delete': _ctx.showDelete}])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sharedTo, (label, index) => {
          return (_openBlock(), _createBlock(_component_app_label, {
            onClick: _withModifiers(($event: any) => (_ctx.goToChat(label.id, label.isGroup)), ["prevent"]),
            key: index
          }, {
            image: _withCtx(() => [
              _createElementVNode("img", {
                class: "img-item",
                src: _ctx.resolvePhoto(label),
                alt: ""
              }, null, 8, _hoisted_1)
            ]),
            default: _withCtx(() => [
              _createTextVNode(" " + _toDisplayString(label.name) + " ", 1),
              (_ctx.showDelete)
                ? (_openBlock(), _createElementBlock("i", {
                    key: 0,
                    onClick: ($event: any) => (_ctx.removeShare(label)),
                    class: "delete-btn icon icon-close"
                  }, null, 8, _hoisted_2))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["onClick"]))
        }), 128))
      ], 2))
    : _createCommentVNode("", true)
}